module.exports = __webpack_public_path__ + "img/zzkf.488ba674.jpg";